import React, { Component } from 'react';
import { loadScripts } from '../../utils.js';
import './data.css';

export default class DataPage extends Component {
  componentDidMount() {
    // @TODO original prototype tool was developed in jQuery, rewrite to React in future
    const parent = document.getElementsByClassName('data-page')[0];
    loadScripts(['/jquery/jquery.data.js'], parent, () => {
      const entityUUID = this.props.location.state && this.props.location.state.activeEntity;
      const yearUUID = this.props.location.state && this.props.location.state.activeYear;
      // jQuery is global via /public/index.html
      // eslint-disable-next-line
      window.$(".data-page").mdData({
        tableUrl: `/sites/default/files/data/tables-${entityUUID}_${yearUUID}.txt`,
      });
    });
  }

  componentWillUpdate() {
  }

  componentWillUnmount() {
    // @TODO beware of memory leaks?
  }

  render() {
    return (
      <div className='data-page' />
    );
  }
}
